import React, { FC, useEffect } from 'react'
import { Button } from '@progress/kendo-react-buttons'
import {
  Splitter,
  SplitterOnChangeEvent,
  StackLayout
} from '@progress/kendo-react-layout'
import { PageChangeEvent, Pager } from '@progress/kendo-react-data-tools'
import { Contents } from './Contents'

import './SearchBody.css'

export interface SearchBodyProps {
  leftPane?: React.ReactNode
  leftPaneButton?: React.ReactNode
  rightPane?: React.ReactNode
  rightPaneButton?: React.ReactNode
  pageable?: boolean
  total?: number
  changeSkip?: React.Dispatch<React.SetStateAction<number>> | ((skip: number) => void)
  changeSkipBuilding?: (skip: number) => void
  skip?: number
}

export const SearchBody: FC<SearchBodyProps> = (props) => {
  const pageable = props.pageable === undefined ? true : props.pageable
  const [panes, setPanes] = React.useState<any[]>([
    { size: '25%', min: '150px', resizable: true, collapsible: true }
  ])

  const [take, setTake] = React.useState(20)

  const ref = React.createRef<HTMLDivElement>()

  function onResized(event: SplitterOnChangeEvent) {
    setPanes(event.newState)
  }

  const handlePageChange = (event: PageChangeEvent) => {
    if (props.changeSkip !== undefined && props.changeSkipBuilding === undefined) {
      props.changeSkip(event.skip)
    }
    if (props.changeSkipBuilding !== undefined) {
      props.changeSkipBuilding(event.skip)
    }
    setTake(event.take)
    scrollToStartOfList()
  }

  const scrollToStartOfList = React.useCallback(() => {
    ref.current?.scrollTo({ top: 0, behavior: 'auto' })
  }, [ref])

  useEffect(() => {
    scrollToStartOfList()
  }, [props.skip])

  return (
    <Splitter
      panes={panes}
      onChange={onResized}
      className="pcy-search-body-splitter"
      orientation="horizontal"
    >
      <div className="pcy-search-body-pane">
        <div className="pcy-search-body-pane-content">
          <Contents>{props.leftPane}</Contents>
        </div>
        <div className="pcy-search-body-pane-footer pcy-control-box">
          <StackLayout gap={5}>
            {props.leftPaneButton ?? (
              <>
                <Button>クリア</Button>
                <Button themeColor="primary">検索</Button>
              </>
            )}
          </StackLayout>
        </div>
      </div>
      <div className="pcy-search-body-pane">
        <div className="pcy-search-body-pane-content" ref={ref}>
          <Contents>
            {props.rightPane}
            {pageable
              ? (
              <Pager
                total={props.total !== undefined ? props.total : 1000}
                skip={props.skip !== undefined ? props.skip : 0}
                take={take}
                onPageChange={handlePageChange}
                previousNext
                responsive
                className="pcy-search-body-pager k-pager-wrap"
              />
                )
              : (
                  ''
                )}
          </Contents>
        </div>
        <div className="pcy-search-body-pane-footer pcy-control-box">
          <StackLayout gap={5} align={{ horizontal: 'end' }}>
            {props.rightPaneButton}
          </StackLayout>
        </div>
      </div>
    </Splitter>
  )
}
